import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CustomerAuthService } from '../services/customer-auth.service';

export const customerAuthGuard: CanActivateFn = () => {
  const customerAuthService = inject(CustomerAuthService);
  const router = inject(Router);
  if (customerAuthService.isLoggedIn()) {
    return true;
  }
  router.navigate(['/customer-submission/login']);
  return false;
};
